export function isPlainObject (value: unknown): value is Record<string, unknown> {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function mergeDeep<T extends Record<string, unknown>> (target: T, update: Partial<T>): T {
    const merged = { ...target } as Record<string, unknown>;

    Object.entries(update).forEach(([key, value]) => {
        const current = merged[key];
        if (isPlainObject(current) && isPlainObject(value)) {
            merged[key] = mergeDeep(current, value);
            return;
        }
        merged[key] = value;
    });

    return merged as T;
}
